module.exports = __webpack_public_path__ + "img/yuanwei1.c4d74b18.png";